<template>
    <div>
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form 
                    :form="queryForm" 
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <!-- <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span> -->
            </div>
        </div>

        <Table 
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <!-- 自定义字段 -->
            <template v-slot:columns="{ props }">
                <div v-if="props.column.key == 'handle_data'">
                    <a-tag :color="props.record.handle_data == 0? 'gray' : props.record.handle_data == 2? 'green' : 'blue'">{{ props.record.handle_data_text }}</a-tag>
                </div>
            </template>
        </Table>
    </div>
</template>

<script setup>
    import { onMounted, reactive, ref, watch, nextTick } from 'vue';
    import { LogApi } from '@/api/LogApi.js';
    import { StockOutApi } from '@/api/StockOutApi.js';
    import { Message } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { RiskLogQuery } from './queryConfig/ErrorLogQuery.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { dateToTimestamp, timestampToDate } from '@/utils/index.js';

    const localeStore = useLocale()

    const { t } = useI18n()

    const showForm = ref(false)
    const queryForm = reactive(RiskLogQuery)
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
                fixed:'left',
                align:'center',
            },
            {
                // title: '订单编号',
                title: t('log.orderName'),
                dataIndex: 'key_name',
                key:'key_name',
                width:'140',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
            // {
            //     // title: '模块',
            //     title: t('log.model'),
            //     dataIndex: 'model',
            //     key:'model',
            //     width:'120',
            //     ellipsis:true,
            //     tooltip:true,  
            //     align:'center',
            // },
            // {
            //     // title: '类型',
            //     title: t('log.type'),
            //     dataIndex: 'type',
            //     key:'type',
            //     width:'150',
            //     ellipsis:true,
            //     tooltip:true,  
            //     align:'center',
            // },
            {
                // title: '风险验证状态',
                title: t('log.handleData'),
                dataIndex: 'handle_data',
                key:'handle_data',
                width:'150',
                ellipsis:true,
                tooltip:true,  
                align:'center',
                slotName:'slot',
            },
            {
                // title: '创建日期',
                title: t('log.createTimestamp'),
                dataIndex: 'create_timestamp',
                key:'create_timestamp',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
            {
                // title: '更新人',
                title: t('log.updateUser'),
                dataIndex: 'update_user',
                key:'update_user',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
        ],
        configs:{
            scroll:{
                x:1000,
                y:480,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                size:'mini',
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
            
        },
    })

    const showFormPanel = (val)=>{
        showForm.value = val
    }

    const handle = (type,row)=>{
        switch(type){
            case 'search':
                getLogList()
                break;
            case 'reset':
                queryForm.formField.forEach(item=>{
                    queryForm.formData[item.key] = ''
                })
                getLogList()
                break;
        }
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getLogList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getLogList()
    }

    // 列表查询-select
    const handleSelectChange = (val,opt,key)=>{
        console.log(val,opt,key,'val,opt,key')
        queryForm.formData[key] = val
        table.value.configs.pagination.current = 1
        getLogList()
    }

    // 列表查询-input
    const handleInputClear = (item, val)=>{
        table.value.configs.pagination.current = 1
        getLogList()
    }
    const handlePressEnter = (val,item)=>{
        table.value.configs.pagination.current = 1
        getLogList()
    }

    // 获取日志列表
    const getLogList = async ()=>{
        let param = {
            model: "ORDER",
            type: "RISK_VALIDATE",
            key_name:queryForm.formData.key_name.trim(),
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await LogApi.getInstance().getRiskVerificationLogLog(param, page_num, page_size)
        if(res.code == 0){
            table.value.datas = []
            res.data.records.length > 0 && res.data.records.forEach((item,index)=>{
                table.value.datas.push({
                    ...item,
                    No: index + 1,
                    handle_data: JSON.parse(item.handle_data)[item.type],
                    handle_data_text: JSON.parse(item.handle_data)[item.type] == 0? t('log.noValid') : JSON.parse(item.handle_data)[item.type] == 2? t('log.isRelieve') : JSON.parse(item.handle_data)[item.type] == 1? t('log.isValid') : '-', 
                    create_timestamp: item.create_timestamp == undefined? '-' : timestampToDate(item.create_timestamp  * 1000),
                })
            })
            table.value.configs.pagination.total = res.data.total
            table.value.configs.pagination.current = res.data.current
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 处理查询面板伸缩时表格高度
    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        const searchContentDomHeight = document.querySelector('.queryPanel').clientHeight
        const pageHeight = 50
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight - pageHeight - footerHeight - 60
    }

    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })

    onMounted(()=>{
        getLogList()

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })
    })

</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    margin-bottom:7px;
    padding:7px;
    background: #fff;

    .queryPanel_form{
        display: flex;
        flex:6;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        // flex-direction: column;
        // flex-wrap:wrap;
        flex: 1;
        align-items: center;
        justify-content: center;
        border-left:1px solid #eee;
        padding-left:10px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    /deep/ .arco-form-item-layout-inline{
        margin-right: 0;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:90px;
    }
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    // padding: 10px 0;
    font-size: 13px;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 10px 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}

.addForm{
    /deep/ .arco-input-wrapper,
    /deep/ .arco-picker-size-medium{
        height: 45px;
    }

    /deep/ .arco-form-item-label-col{
        line-height: 45px;
    }
}

</style>